var Direction;
(function (Direction) {
    Direction["West"] = "west";
    Direction["East"] = "east";
    Direction["North"] = "north";
    Direction["South"] = "south";
})(Direction || (Direction = {}));

export { Direction };
//# sourceMappingURL=direction.js.map
